import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ExternalLink, Mail, FileSignature } from "lucide-react";
import { Link } from "react-router-dom";

export default function Tools() {
  const [tools, setTools] = useState([]);
  useEffect(() => { api.get("/content/tools").then(r => setTools((r.data || []).sort((a, b) => a.order - b.order))); }, []);
  return (
    <div className="space-y-7" data-testid="tools-page">
      <header>
        <div className="overline">Brokerage</div>
        <h1 className="font-heading text-5xl mt-2">Tools & Tech Stack</h1>
        <p className="text-sm text-[#050303]/70 mt-2">Curated tools · onboarding order · one-click visit.</p>
      </header>

      <Link
        to="/newsletter"
        className="core-card p-6 flex items-center justify-between hover:-translate-y-0.5 hover:shadow-lg transition-all bg-gradient-to-r from-white to-[#e1b7c1]/40 block"
        data-testid="tool-newsletter"
      >
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-[#e1b7c1] text-[#050303] flex items-center justify-center">
            <Mail size={20} strokeWidth={1.5} />
          </div>
          <div>
            <div className="overline">CORE Exclusive</div>
            <div className="font-heading text-2xl mt-0.5">Newsletter Builder</div>
            <div className="text-sm text-[#050303]/70 mt-1">Compose branded monthly newsletters and send to your client list. Header + footer locked to CORE branding.</div>
          </div>
        </div>
        <span className="text-sm font-semibold text-[#bf858e] hover:text-[#050303] whitespace-nowrap">Open Builder →</span>
      </Link>

      <Link
        to="/pay-at-closing"
        className="core-card p-6 flex items-center justify-between hover:-translate-y-0.5 hover:shadow-lg transition-all bg-gradient-to-r from-white to-[#e1b7c1]/40 block"
        data-testid="tool-pay-at-closing"
      >
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-[#e1b7c1] text-[#050303] flex items-center justify-center">
            <FileSignature size={20} strokeWidth={1.5} />
          </div>
          <div>
            <div className="overline">Form #11 · Digital</div>
            <div className="font-heading text-2xl mt-0.5">Pay-At-Closing Instructions</div>
            <div className="text-sm text-[#050303]/70 mt-1">Fill, sign, and download the CORE closing-attorney commission instructions. Auto-emails a copy to the broker.</div>
          </div>
        </div>
        <span className="text-sm font-semibold text-[#bf858e] hover:text-[#050303] whitespace-nowrap">Open Form →</span>
      </Link>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        {tools.map(t => (
          <div key={t.id} className="core-card p-5 hover:-translate-y-1 transition-transform flex flex-col" data-testid={`tool-${t.id}`}>
            <div className="flex items-center justify-between">
              <span className="w-8 h-8 rounded-full bg-[#050303] text-white text-xs font-bold flex items-center justify-center">{t.order}</span>
              <span className="overline">{t.category}</span>
            </div>
            <div className="font-heading text-xl mt-4">{t.name}</div>
            <div className="text-xs text-[#050303]/70 mt-2 leading-relaxed flex-1">{t.purpose}</div>
            <div className="mt-4 pt-4 border-t border-[#d1cece]">
              {t.url ? (
                <a
                  href={t.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#bf858e] hover:text-[#050303] transition-colors"
                  data-testid={`tool-visit-${t.id}`}
                >
                  visit <ExternalLink size={13} strokeWidth={1.75} />
                </a>
              ) : (
                <span className="text-sm text-[#050303]/40">visit</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
